import { render, staticRenderFns } from "./FallingItemsCanvas.vue?vue&type=template&id=3c2d6d97&scoped=true&"
import script from "./FallingItemsCanvas.vue?vue&type=script&lang=js&"
export * from "./FallingItemsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FallingItemsCanvas.vue?vue&type=style&index=0&id=3c2d6d97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d6d97",
  null
  
)

export default component.exports